import { englishType } from 'types'

export const lesson25: englishType[] = [
  {
    id: 1,
    word: 'break down',
    meaning: ['고장나다', '부수다'],
  },
  {
    id: 2,
    word: 'conceal',
    meaning: ['감추다', '숨기다'],
  },
  {
    id: 3,
    word: 'contain',
    meaning: ['포함하다'],
  },
  {
    id: 4,
    word: 'corrosion',
    meaning: ['부식'],
  },
  {
    id: 5,
    word: 'court',
    meaning: ['법정', '법원'],
  },
  {
    id: 6,
    word: 'critical',
    meaning: ['중요한', '비판적인'],
  },
  {
    id: 7,
    word: 'curious',
    meaning: ['궁금한', '호기심있는'],
  },
  {
    id: 8,
    word: 'delicate',
    meaning: ['연약한', '섬세한', '우아한'],
  },
  {
    id: 9,
    word: 'disassemble',
    meaning: ['분해하다'],
  },
  {
    id: 10,
    word: 'elaborate',
    meaning: ['정교한'],
  },
  {
    id: 11,
    word: 'elegant',
    meaning: ['고상한', '우아한'],
  },
  {
    id: 12,
    word: 'fortress',
    meaning: ['요새'],
  },
  {
    id: 13,
    word: 'heritage',
    meaning: ['유산'],
  },
  {
    id: 14,
    word: 'identity',
    meaning: ['정체성'],
  },
  {
    id: 15,
    word: 'illegally',
    meaning: ['불법적으로'],
  },
  {
    id: 16,
    word: 'loyalty',
    meaning: ['충성심'],
  },
  {
    id: 17,
    word: 'preserve',
    meaning: ['보존하다'],
  },
  {
    id: 18,
    word: 'restore',
    meaning: ['복원하다'],
  },
  {
    id: 19,
    word: 'reveal',
    meaning: ['드러나다', '밝히다'],
  },
  {
    id: 20,
    word: 'transport',
    meaning: ['운반하다', '수송하다'],
  },
  {
    id: 21,
    word: 'glaze',
    meaning: ['유약'],
  },
  {
    id: 22,
    word: 'determine',
    meaning: ['결정하다'],
  },
]
